import React from "react";
import Card from "../../components/_subscription_plans/Card/Card";
import Layout from "../../shared/Layout/Layout";
import leftArrow from "../../assets/leftArrow.svg"
import styles from "./SubscriptionPlans.module.scss";

const SubscriptionPlans = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div className={styles.leftArrow}>
            <img src={leftArrow} alt="go-back" />
          </div>
          <h1>Subscription plans</h1>
          <div className={styles.cardsContainer}>
            <Card
              variant="primary"
              name="Basic"
              amount="14"
              duration="month"
              features={[
                "Upto 500 Uploads",
                "1 GB cloud storage",
                "5 collections",
              ]}
            />
            <Card
              variant="secondary"
              name="Standard"
              amount="29"
              duration="month"
              features={[
                "Upto 10,000 uploads",
                "10 GB cloud storage",
                "25 collections",
              ]}
            />
            <Card
              variant="primary"
              name="ENTERPRISE"
              amount="139"
              duration="month"
              features={[
                "Unlimited uploads",
                "Unlimited cloud storage",
                "Unlimited collections",
              ]}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SubscriptionPlans;
